import { http } from 'vue'

export default {
  loadText (context, params = {}) {
    return http.get('texts/' + params.id)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/texts/actions.js